import { translate } from '../i18n';

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 32;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const getUsernameRequirements = (username = '', t = translate) => {
  const value = username.trim();

  return [
    {
      id: 'username-length',
      label: t('auth.requirements.length', {
        min: USERNAME_MIN_LENGTH,
        max: USERNAME_MAX_LENGTH
      }),
      met: value.length >= USERNAME_MIN_LENGTH && value.length <= USERNAME_MAX_LENGTH
    },
    {
      id: 'username-format',
      label: t('auth.requirements.usernameCharacters'),
      met: /^[A-Za-z0-9_]+$/.test(value)
    }
  ];
};

export const getPasswordRequirements = (password = '', t = translate) => {
  return [
    {
      id: 'password-length',
      label: t('auth.requirements.length', {
        min: PASSWORD_MIN_LENGTH,
        max: PASSWORD_MAX_LENGTH
      }),
      met: password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH
    },
    {
      id: 'password-uppercase',
      label: t('auth.requirements.uppercase'),
      met: /[A-Z]/.test(password)
    },
    {
      id: 'password-lowercase',
      label: t('auth.requirements.lowercase'),
      met: /[a-z]/.test(password)
    },
    {
      id: 'password-number',
      label: t('auth.requirements.number'),
      met: /\d/.test(password)
    },
    {
      id: 'password-symbol',
      label: t('auth.requirements.symbol'),
      met: /[^A-Za-z0-9\s]/.test(password)
    }
  ];
};

export const areRequirementsMet = (requirements) => {
  return requirements.every((requirement) => requirement.met);
};
